import { createApp } from "vue";
import { VueQueryPlugin } from "@tanstack/vue-query";
import highrise from "@platform-ui/highrise";
import "@platform-ui/highrise/style.css";
import i18n from "@documentx/shared/locales";
import router from "./router";
import App from "./App.vue";
import "./style.css";

const app = createApp(App);
app.use(i18n);
app.use(router);
app.use(VueQueryPlugin);
app.use(highrise);
app.mount("#app");
